import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfileSettings } from "./modules/profile_settings";
import { ContactUs } from "./modules/contact_us/pages/contactUs";
import { QuoteData } from "./modules/quote/pages/quote";
import { GenerativeAIData } from "./modules/generativeAI/pages/generativaAI";
import { CareersData } from "./modules/careers/pages/careers";
import ViewContactUs from "./modules/contact_us/pages/viewContactUs";
import ViewQuote from "./modules/quote/pages/viewQuote";
import ViewGenerativeAI from "./modules/generativeAI/pages/viewgenerativaAI";
import ViewCareers from "./modules/careers/pages/viewCareers";
import { Tag } from "./modules/tag/pages/tag";
import addTag from "./modules/tag/pages/addTag";
import DubaiAddTag from "./modules/Dubai_tag/pages/dubaiaddTag";
import { Blog } from "./modules/blog/pages/blog";
import { DubaiBlog } from "./modules/dubai_blog/pages/dubaiblog";
import dubaiaddBlog from "./modules/dubai_blog/pages/dubaiaddBlog";
import { DubaiTag } from "./modules/Dubai_tag/pages/dubaitag";

import addBlog from "./modules/blog/pages/addBlog";
import { Category } from "./modules/Category/pages/category";
import { DubaiCategory } from "./modules/Dubai_Category/pages/dubaicategory";
import addCategory from "./modules/Category/pages/addCategory";
import DubaiAddCategory from "./modules/Dubai_Category/pages/addCategory";

import { EmailManagement } from "./modules/emailManagement/pages/emailManagement";
import AddTemplate from "./modules/emailManagement/pages/AddTemplate";
import { MailSubscriber } from "./modules/mailSubscriber";
import { WhatsAppAccount } from "./modules/whatsApp";
import UpdateSubUser from "./modules/users/pages/createUser";
import { Users } from "./modules/users";
import { useIsAccessAllow } from "./modules/users/redux";
import { PageSpeedScore } from "./modules/pageSpeedScore/PageSpeed";
import { AuthorManagement } from "./modules/AuthorManagement/pages/AuthorManagement";
import AddAuthor from "./modules/AuthorManagement/pages/AddAuthor";
import { DubaiAuthorManagement } from "./modules/Dubai_AuthorManagement/pages/DubaiAuthorManagement";
import DubaiAddAuthor from "./modules/Dubai_AuthorManagement/pages/DubaiAddAuthor";
import { HireAIBlog } from "./modules/Hire_ai_blog";
import AddHireAIBlog from "./modules/Hire_ai_blog/pages/hireaiaddBlog";
import { HireAITag } from "./modules/Hire_ai_tag";
import HireAITagAdd from "./modules/Hire_ai_tag/pages/hireaiaddTag";
import { HireAICategory } from "./modules/hire_ai_Category";
import HireAIAddCategory from "./modules/hire_ai_Category/pages/addCategory";
import { HireAIAuthor, hireAIAuthor } from "./modules/hire_ai_author";
import HireAIAddAuthor from "./modules/hire_ai_author/pages/HireAIAddAuthor";
import { HfdiBlog } from "./modules/Hfdi_blog/pages/HfdiBlog";
import AddHfdiBlog from "./modules/Hfdi_blog/pages/HfdiaddBlog";
import { HfdiTag } from "./modules/Hfdi_tag";
import HfdiTagAdd from "./modules/Hfdi_tag/pages/hfdiaddTag";
import { HfdiCategory } from "./modules/hfdi_Category";
import HfdiAddCategory from "./modules/hfdi_Category/pages/addCategory";
import { HfdiAuthor } from "./modules/hfdi_author";
import HfdiAddAuthor from "./modules/hfdi_author/pages/HfdiAddAuthor";
import { HfdiCareers } from "./modules/Hfdi_careers";
import HfdiCareersAdd from "./modules/Hfdi_careers/pages/hfdiaddCareers";
import { HfdiCareersInquiry } from "./modules/Hfdi_Careers_Inquiry/pages/hfdicareersinquiry";
import ViewCareersInquiry from "./modules/Hfdi_Careers_Inquiry/pages/viewHfdiCareersInquiry";
import { WebcluesCareers } from "./modules/Webclues_careers";
import WebcluesCareersAdd from "./modules/Webclues_careers/pages/webcluesaddCareers";
import { WebCareersCity } from "./modules/webCareersCity";
import AddWebCareersCity from "./modules/webCareersCity/pages/webcareerscityadd";

import { IcodBlog } from "./modules/Icod_blog/pages/icodBlog";
import AddIcodBlog from "./modules/Icod_blog/pages/icodaddBlog";
import { IcodTag } from "./modules/Icod_tag";
import IcodTagAdd from "./modules/Icod_tag/pages/icodaddTag";
import { IcodCategory } from "./modules/icod_Category";
import IcodAddCategory from "./modules/icod_Category/pages/addCategory";
import { IcodAuthor } from "./modules/icod_author";
import IcodAddAuthor from "./modules/icod_author/pages/IcodAddAuthor";

import { FdcBlog } from "./modules/Fdc_blog/pages/FdcBlog";
import AddFdcBlog from "./modules/Fdc_blog/pages/FdcaddBlog";
import { FdcTag } from "./modules/Fdc_tag";
import FdcTagAdd from "./modules/Fdc_tag/pages/fdcaddTag";
import { FdcCategory } from "./modules/fdc_Category";
import FdcAddCategory from "./modules/fdc_Category/pages/addCategory";
import { FdcAuthor } from "./modules/fdc_author";
import FdcAddAuthor from "./modules/fdc_author/pages/fdcAddAuthor";

import { HbdBlog } from "./modules/Hbd_blog/pages/HbdBlog";
import AddHbdBlog from "./modules/Hbd_blog/pages/HbdaddBlog";
import { HbdTag } from "./modules/Hbd_tag";
import HbdTagAdd from "./modules/Hbd_tag/pages/hbdaddTag";
import { HbdCategory } from "./modules/hbd_Category";
import HbdAddCategory from "./modules/hbd_Category/pages/addCategory";
import { HbdAuthor } from "./modules/Hbd_author";
import HbdAddAuthor from "./modules/Hbd_author/pages/hbdAddAuthor";

import { BdcBlog } from "./modules/Bdc_blog/pages/BdcBlog";
import AddBdcBlog from "./modules/Bdc_blog/pages/BdcaddBlog";
import { BdcTag } from "./modules/Bdc_tag";
import BdcTagAdd from "./modules/Bdc_tag/pages/bdcaddTag";
import { BdcCategory } from "./modules/bdc_Category";
import BdcAddCategory from "./modules/bdc_Category/pages/addCategory";
import { BdcAuthor } from "./modules/Bdc_author";
import BdcAddAuthor from "./modules/Bdc_author/pages/bdcAddAuthor";

import { HfdBlog } from "./modules/Hfd_blog/pages/hfdBlog";
import AddHfdBlog from "./modules/Hfd_blog/pages/hfdaddBlog";
import { HfdTag } from "./modules/Hfd_tag";
import HfdTagAdd from "./modules/Hfd_tag/pages/hfdaddTag";
import { HfdCategory } from "./modules/hfd_Category";
import HfdAddCategory from "./modules/hfd_Category/pages/addCategory";
import { HfdAuthor } from "./modules/hfd_author";
import HfdAddAuthor from "./modules/hfd_author/pages/hfdAddAuthor";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/dashboard" />}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/profile-settings" component={ProfileSettings} />
        <ContentRoute
          exact
          path="/user"
          component={Users}
          title="Users"
          isAccessAllow={useIsAccessAllow("user.list")}
        />
        <ContentRoute
          exact
          path="/user/add-user"
          component={UpdateSubUser}
          title="Add User"
          isAccessAllow={useIsAccessAllow("user.add_user")}
        />
        <ContentRoute
          exact
          path="/user/edit-user/:id"
          component={UpdateSubUser}
          title="Update User"
          isAccessAllow={useIsAccessAllow("user.edit_user")}
        />
        {/* <ContentRoute
          exact
          path="/role"
          component={UpdateSubUser}
          title="Role"
        /> */}
        <ContentRoute
          exact
          path="/contact-us"
          component={ContactUs}
          isAccessAllow={useIsAccessAllow("contact_us.list")}
        />
        <ContentRoute
          exact
          path="/contact-us/view-contact-us/:id"
          component={ViewContactUs}
          isAccessAllow={useIsAccessAllow("contact_us.view")}
        />
        <ContentRoute
          exact
          path="/contact-us/:pageType"
          component={ContactUs}
        />
        <ContentRoute
          exact
          path="/quote"
          component={QuoteData}
          isAccessAllow={useIsAccessAllow("get_a_quote.list")}
        />
        <ContentRoute exact path="/quote/:pageType" component={QuoteData} />
        <ContentRoute
          exact
          path="/quote/view-quote/:id"
          component={ViewQuote}
          isAccessAllow={useIsAccessAllow("get_a_quote.view")}
        />
        <ContentRoute
          exact
          path="/generativeAI"
          component={GenerativeAIData}
          isAccessAllow={useIsAccessAllow("get_genAI_quote.list")}
        />
        <ContentRoute
          exact
          path="/generativeAI/:pageType"
          component={GenerativeAIData}
        />
        <ContentRoute
          exact
          path="/generativeAI/view-generativeAI/:id"
          component={ViewGenerativeAI}
          isAccessAllow={useIsAccessAllow("get_genAI_quote.view")}
        />
        <ContentRoute
          exact
          path="/careers"
          component={CareersData}
          isAccessAllow={useIsAccessAllow("careers.list")}
        />
        <ContentRoute
          exact
          path="/careers/view-careers/:id"
          component={ViewCareers}
          isAccessAllow={useIsAccessAllow("careers.view")}
        />
        {/* Webclues Author Start */}
        <ContentRoute
          exact
          path="/tag"
          component={Tag}
          isAccessAllow={useIsAccessAllow("tag.list")}
        />
        <ContentRoute
          exact
          path="/tag/add-tag"
          component={addTag}
          isAccessAllow={useIsAccessAllow("tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/tag/edit-tag/:id"
          component={addTag}
          isAccessAllow={useIsAccessAllow("tag.edit_tag")}
        />
        <ContentRoute
          exact
          path="/blog"
          component={Blog}
          isAccessAllow={useIsAccessAllow("blog.list")}
        />
        <ContentRoute
          exact
          path="/blog/add-blog"
          component={addBlog}
          isAccessAllow={useIsAccessAllow("blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/blog/edit-blog/:id"
          component={addBlog}
          isAccessAllow={useIsAccessAllow("blog.edit_blog")}
        />
        <ContentRoute
          exact
          path="/author"
          component={AuthorManagement}
          isAccessAllow={useIsAccessAllow("author.list")}
        />
        <ContentRoute
          exact
          path="/author/add-author"
          component={AddAuthor}
          isAccessAllow={useIsAccessAllow("author.add_author")}
        />
        <ContentRoute
          exact
          path="/author/edit-author/:id"
          component={AddAuthor}
          isAccessAllow={useIsAccessAllow("author.edit_author")}
        />
        {/* Webclues Author END */}
        {/* DUBAI Author Start */}
        <ContentRoute
          exact
          path="/dubai_tag"
          component={DubaiTag}
          isAccessAllow={useIsAccessAllow("dubai_tag.list")}
        />
        <ContentRoute
          exact
          path="/dubai_tag/add-tag"
          component={DubaiAddTag}
          isAccessAllow={useIsAccessAllow("dubai_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/dubai_tag/edit-tag/:id"
          component={DubaiAddTag}
          isAccessAllow={useIsAccessAllow("dubai_tag.edit_tag")}
        />
        <ContentRoute
          exact
          path="/dubai_blog"
          component={DubaiBlog}
          isAccessAllow={useIsAccessAllow("dubai_blog.list")}
        />
        <ContentRoute
          exact
          path="/dubai_blog/add-blog"
          component={dubaiaddBlog}
          isAccessAllow={useIsAccessAllow("dubai_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/dubai_blog/edit-blog/:id"
          component={dubaiaddBlog}
          isAccessAllow={useIsAccessAllow("dubai_blog.edit_blog")}
        />
        <ContentRoute
          exact
          path="/dubai_author"
          component={DubaiAuthorManagement}
          isAccessAllow={useIsAccessAllow("dubai_author.list")}
        />
        <ContentRoute
          exact
          path="/dubai_author/add-author"
          component={DubaiAddAuthor}
          isAccessAllow={useIsAccessAllow("dubai_author.add_author")}
        />
        <ContentRoute
          exact
          path="/dubai_author/edit-author/:id"
          component={DubaiAddAuthor}
          isAccessAllow={useIsAccessAllow("dubai_author.edit_author")}
        />
        <ContentRoute
          exact
          path="/dubai_category"
          component={DubaiCategory}
          isAccessAllow={useIsAccessAllow("dubai_category.list")}
        />
        <ContentRoute
          exact
          path="/dubai_category/add-category"
          component={DubaiAddCategory}
          isAccessAllow={useIsAccessAllow("dubai_category.add_category")}
        />
        <ContentRoute
          exact
          path="/dubai_category/edit-category/:id"
          component={DubaiAddCategory}
          isAccessAllow={useIsAccessAllow("dubai_category.edit_category")}
        />
        {/* DUBAI Author End */}
        <ContentRoute
          exact
          path="/email-management"
          component={EmailManagement}
          isAccessAllow={useIsAccessAllow("email_management.list")}
        />
        <ContentRoute
          exact
          path="/email-management/add-template"
          component={AddTemplate}
          isAccessAllow={useIsAccessAllow("email_management.add_template")}
        />
        <ContentRoute
          exact
          path="/email-management/edit-template/:id"
          component={AddTemplate}
          isAccessAllow={useIsAccessAllow("email_management.edit_template")}
        />
        <ContentRoute
          exact
          path="/category"
          component={Category}
          isAccessAllow={useIsAccessAllow("category.list")}
        />
        <ContentRoute
          exact
          path="/category/add-category"
          component={addCategory}
          isAccessAllow={useIsAccessAllow("category.add_category")}
        />
        <ContentRoute
          exact
          path="/category/edit-category/:id"
          component={addCategory}
          isAccessAllow={useIsAccessAllow("category.edit_category")}
        />
        <ContentRoute
          exact
          path="/mail-subscribers"
          component={MailSubscriber}
          isAccessAllow={useIsAccessAllow("mail_subscribers.list")}
        />
        <ContentRoute
          exact
          path="/whatsapp/accounts"
          component={WhatsAppAccount}
        />
        <ContentRoute
          exact
          path="/page-speed"
          component={PageSpeedScore}
          isAccessAllow={useIsAccessAllow("pagespeed_score.list")}
        />
        {/* Hire AI Blog Route Start */}
        <ContentRoute
          exact
          path="/hire_ai_blog"
          component={HireAIBlog}
          isAccessAllow={useIsAccessAllow("hire_ai_blog.list")}
        />
        <ContentRoute
          exact
          path="/hire_ai_blog/add-blog"
          component={AddHireAIBlog}
          isAccessAllow={useIsAccessAllow("hire_ai_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/hire_ai_blog/edit-blog/:id"
          component={AddHireAIBlog}
          isAccessAllow={useIsAccessAllow("hire_ai_blog.edit_blog")}
        />
        {/* Hire AI Blog Route End */}
        {/* Hire AI tag Route Start */}
        <ContentRoute
          exact
          path="/hire_ai_tag"
          component={HireAITag}
          isAccessAllow={useIsAccessAllow("hire_ai_tag.list")}
        />
        <ContentRoute
          exact
          path="/hire_ai_tag/add-tag"
          component={HireAITagAdd}
          isAccessAllow={useIsAccessAllow("hire_ai_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/hire_ai_tag/edit-tag/:id"
          component={HireAITagAdd}
          isAccessAllow={useIsAccessAllow("hire_ai_tag.edit_tag")}
        />
        {/* Hire AI tag Route End */}
        {/* Hire AI Category Route Start */}
        <ContentRoute
          exact
          path="/hire_ai_category"
          component={HireAICategory}
          isAccessAllow={useIsAccessAllow("hire_ai_category.list")}
        />
        <ContentRoute
          exact
          path="/hire_ai_category/add-category"
          component={HireAIAddCategory}
          isAccessAllow={useIsAccessAllow("hire_ai_category.add_category")}
        />
        <ContentRoute
          exact
          path="/hire_ai_category/edit-category/:id"
          component={HireAIAddCategory}
          isAccessAllow={useIsAccessAllow("hire_ai_category.edit_category")}
        />
        {/* Hire AI Category Route End */}
        {/* Hire AI Author Route Start */}
        <ContentRoute
          exact
          path="/hire_ai_author"
          component={HireAIAuthor}
          isAccessAllow={useIsAccessAllow("hire_ai_author.list")}
        />
        <ContentRoute
          exact
          path="/hire_ai_author/add-author"
          component={HireAIAddAuthor}
          isAccessAllow={useIsAccessAllow("hire_ai_author.add_author")}
        />
        <ContentRoute
          exact
          path="/hire_ai_author/edit-author/:id"
          component={HireAIAddAuthor}
          isAccessAllow={useIsAccessAllow("hire_ai_author.edit_author")}
        />
        {/* Hire AI Author Route End */}
        {/* HFDI Blog Route Start */}
        <ContentRoute
          exact
          path="/hfdi_blog"
          component={HfdiBlog}
          isAccessAllow={useIsAccessAllow("hfdi_blog.list")}
        />
        <ContentRoute
          exact
          path="/hfdi_blog/add-blog"
          component={AddHfdiBlog}
          isAccessAllow={useIsAccessAllow("hfdi_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/hfdi_blog/edit-blog/:id"
          component={AddHfdiBlog}
          isAccessAllow={useIsAccessAllow("hfdi_blog.edit_blog")}
        />
        {/* HFDI Blog Route End */}
        {/* HFDI tag Route Start */}
        <ContentRoute
          exact
          path="/hfdi_tag"
          component={HfdiTag}
          isAccessAllow={useIsAccessAllow("hfdi_tag.list")}
        />
        <ContentRoute
          exact
          path="/hfdi_tag/add-tag"
          component={HfdiTagAdd}
          isAccessAllow={useIsAccessAllow("hfdi_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/hfdi_tag/edit-tag/:id"
          component={HfdiTagAdd}
          isAccessAllow={useIsAccessAllow("hfdi_tag.edit_tag")}
        />
        {/* HFDI tag Route End */}
        {/* HFDI Category Route Start */}
        <ContentRoute
          exact
          path="/hfdi_category"
          component={HfdiCategory}
          isAccessAllow={useIsAccessAllow("hfdi_category.list")}
        />
        <ContentRoute
          exact
          path="/hfdi_category/add-category"
          component={HfdiAddCategory}
          isAccessAllow={useIsAccessAllow("hfdi_category.add_category")}
        />
        <ContentRoute
          exact
          path="/hfdi_category/edit-category/:id"
          component={HfdiAddCategory}
          isAccessAllow={useIsAccessAllow("hfdi_category.edit_category")}
        />
        {/* HFDI Category Route End */}
        {/* HFDI Author Route Start */}
        <ContentRoute
          exact
          path="/hfdi_author"
          component={HfdiAuthor}
          isAccessAllow={useIsAccessAllow("hfdi_author.list")}
        />
        <ContentRoute
          exact
          path="/hfdi_author/add-author"
          component={HfdiAddAuthor}
          isAccessAllow={useIsAccessAllow("hfdi_author.add_author")}
        />
        <ContentRoute
          exact
          path="/hfdi_author/edit-author/:id"
          component={HfdiAddAuthor}
          isAccessAllow={useIsAccessAllow("hfdi_author.edit_author")}
        />
        {/* HFDI Author Route End */}
        {/* HFDI Careers Route Start */}`{" "}
        <ContentRoute
          exact
          path="/hfdi_careers"
          component={HfdiCareers}
          isAccessAllow={useIsAccessAllow("hfdi_careers.list")}
        />
        <ContentRoute
          exact
          path="/hfdi_careers/add-careers"
          component={HfdiCareersAdd}
          isAccessAllow={useIsAccessAllow("hfdi_careers.add_careers")}
        />
        <ContentRoute
          exact
          path="/hfdi_careers/edit-careers/:id"
          component={HfdiCareersAdd}
          isAccessAllow={useIsAccessAllow("hfdi_careers.edit_careers")}
        />
        <ContentRoute
          exact
          path="/inquirycareers"
          component={HfdiCareersInquiry}
          isAccessAllow={useIsAccessAllow("inquirycareers.list")}
        />
        <ContentRoute
          exact
          path="/inquirycareers/view-careers-inquiry/:id"
          component={ViewCareersInquiry}
          isAccessAllow={useIsAccessAllow("inquirycareers.view")}
        />
        {/* HFDI Careers Route End */}
        {/* webclues infotech Careers start */}`{" "}
        <ContentRoute
          exact
          path="/webclues_careers"
          component={WebcluesCareers}
          isAccessAllow={useIsAccessAllow("webclues_careers.list")}
        />
        <ContentRoute
          exact
          path="/webclues_careers/add-careers"
          component={WebcluesCareersAdd}
          isAccessAllow={useIsAccessAllow("webclues_careers.add_careers")}
        />
        <ContentRoute
          exact
          path="/webclues_careers/edit-careers/:id"
          component={WebcluesCareersAdd}
          isAccessAllow={useIsAccessAllow("webclues_careers.edit_careers")}
        />
        <ContentRoute
          exact
          path="/web_careers_city"
          component={WebCareersCity}
          isAccessAllow={useIsAccessAllow("webcareerscity.list")}
        />
        <ContentRoute
          exact
          path="/web_careers_city/add-webcareerscity"
          component={AddWebCareersCity}
          isAccessAllow={useIsAccessAllow("webcareerscity.add_webcareerscity")}
        />
        <ContentRoute
          exact
          path="/web_careers_city/edit-webcareerscity/:id"
          component={AddWebCareersCity}
          isAccessAllow={useIsAccessAllow("webcareerscity.edit_webcareerscity")}
        />
        {/* webclues infotech Careers End */}
        {/* ICOD Blog Route Start */}
        <ContentRoute
          exact
          path="/icod_blog"
          component={IcodBlog}
          isAccessAllow={useIsAccessAllow("icod_blog.list")}
        />
        <ContentRoute
          exact
          path="/icod_blog/add-blog"
          component={AddIcodBlog}
          isAccessAllow={useIsAccessAllow("icod_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/icod_blog/edit-blog/:id"
          component={AddIcodBlog}
          isAccessAllow={useIsAccessAllow("icod_blog.edit_blog")}
        />
        {/* ICOD Blog Route End */}
        {/* ICOD tag Route Start */}
        <ContentRoute
          exact
          path="/icod_tag"
          component={IcodTag}
          isAccessAllow={useIsAccessAllow("icod_tag.list")}
        />
        <ContentRoute
          exact
          path="/icod_tag/add-tag"
          component={IcodTagAdd}
          isAccessAllow={useIsAccessAllow("icod_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/icod_tag/edit-tag/:id"
          component={IcodTagAdd}
          isAccessAllow={useIsAccessAllow("icod_tag.edit_tag")}
        />
        {/* ICOD tag Route End */}
        {/* ICOD Category Route Start */}
        <ContentRoute
          exact
          path="/icod_category"
          component={IcodCategory}
          isAccessAllow={useIsAccessAllow("icod_category.list")}
        />
        <ContentRoute
          exact
          path="/icod_category/add-category"
          component={IcodAddCategory}
          isAccessAllow={useIsAccessAllow("icod_category.add_category")}
        />
        <ContentRoute
          exact
          path="/icod_category/edit-category/:id"
          component={IcodAddCategory}
          isAccessAllow={useIsAccessAllow("icod_category.edit_category")}
        />
        {/* ICOD Category Route End */}
        {/* ICOD Author Route Start */}
        <ContentRoute
          exact
          path="/icod_author"
          component={IcodAuthor}
          isAccessAllow={useIsAccessAllow("icod_author.list")}
        />
        <ContentRoute
          exact
          path="/icod_author/add-author"
          component={IcodAddAuthor}
          isAccessAllow={useIsAccessAllow("icod_author.add_author")}
        />
        <ContentRoute
          exact
          path="/icod_author/edit-author/:id"
          component={IcodAddAuthor}
          isAccessAllow={useIsAccessAllow("icod_author.edit_author")}
        />
        {/* ICOD Author Route End */}
        {/* FDC Blog Route Start */}
        <ContentRoute
          exact
          path="/fdc_blog"
          component={FdcBlog}
          isAccessAllow={useIsAccessAllow("fdc_blog.list")}
        />
        <ContentRoute
          exact
          path="/fdc_blog/add-blog"
          component={AddFdcBlog}
          isAccessAllow={useIsAccessAllow("fdc_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/fdc_blog/edit-blog/:id"
          component={AddFdcBlog}
          isAccessAllow={useIsAccessAllow("fdc_blog.edit_blog")}
        />
        {/* FDC Blog Route End */}
        {/* FDC tag Route Start */}
        <ContentRoute
          exact
          path="/fdc_tag"
          component={FdcTag}
          isAccessAllow={useIsAccessAllow("fdc_tag.list")}
        />
        <ContentRoute
          exact
          path="/fdc_tag/add-tag"
          component={FdcTagAdd}
          isAccessAllow={useIsAccessAllow("fdc_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/fdc_tag/edit-tag/:id"
          component={FdcTagAdd}
          isAccessAllow={useIsAccessAllow("fdc_tag.edit_tag")}
        />
        {/* FDC tag Route End */}
        {/* FDC Category Route Start */}
        <ContentRoute
          exact
          path="/fdc_category"
          component={FdcCategory}
          isAccessAllow={useIsAccessAllow("fdc_category.list")}
        />
        <ContentRoute
          exact
          path="/fdc_category/add-category"
          component={FdcAddCategory}
          isAccessAllow={useIsAccessAllow("fdc_category.add_category")}
        />
        <ContentRoute
          exact
          path="/fdc_category/edit-category/:id"
          component={FdcAddCategory}
          isAccessAllow={useIsAccessAllow("fdc_category.edit_category")}
        />
        {/* FDC Category Route End */}
        {/* FDC Author Route Start */}
        <ContentRoute
          exact
          path="/fdc_author"
          component={FdcAuthor}
          isAccessAllow={useIsAccessAllow("fdc_author.list")}
        />
        <ContentRoute
          exact
          path="/fdc_author/add-author"
          component={FdcAddAuthor}
          isAccessAllow={useIsAccessAllow("fdc_author.add_author")}
        />
        <ContentRoute
          exact
          path="/fdc_author/edit-author/:id"
          component={FdcAddAuthor}
          isAccessAllow={useIsAccessAllow("fdc_author.edit_author")}
        />
        {/* FDC Author Route End */}
        {/* HBD Blog Route Start */}
        <ContentRoute
          exact
          path="/hbd_blog"
          component={HbdBlog}
          isAccessAllow={useIsAccessAllow("hbd_blog.list")}
        />
        <ContentRoute
          exact
          path="/hbd_blog/add-blog"
          component={AddHbdBlog}
          isAccessAllow={useIsAccessAllow("hbd_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/hbd_blog/edit-blog/:id"
          component={AddHbdBlog}
          isAccessAllow={useIsAccessAllow("hbd_blog.edit_blog")}
        />
        {/* HBD Blog Route End */}
        {/* HBD tag Route Start */}
        <ContentRoute
          exact
          path="/hbd_tag"
          component={HbdTag}
          isAccessAllow={useIsAccessAllow("hbd_tag.list")}
        />
        <ContentRoute
          exact
          path="/hbd_tag/add-tag"
          component={HbdTagAdd}
          isAccessAllow={useIsAccessAllow("hbd_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/hbd_tag/edit-tag/:id"
          component={HbdTagAdd}
          isAccessAllow={useIsAccessAllow("hbd_tag.edit_tag")}
        />
        {/* HBD tag Route End */}
        {/* HBD Category Route Start */}
        <ContentRoute
          exact
          path="/hbd_category"
          component={HbdCategory}
          isAccessAllow={useIsAccessAllow("hbd_category.list")}
        />
        <ContentRoute
          exact
          path="/hbd_category/add-category"
          component={HbdAddCategory}
          isAccessAllow={useIsAccessAllow("hbd_category.add_category")}
        />
        <ContentRoute
          exact
          path="/hbd_category/edit-category/:id"
          component={HbdAddCategory}
          isAccessAllow={useIsAccessAllow("hbd_category.edit_category")}
        />
        {/* HBD Category Route End */}
        {/* HBD Author Route Start */}
        <ContentRoute
          exact
          path="/hbd_author"
          component={HbdAuthor}
          isAccessAllow={useIsAccessAllow("hbd_author.list")}
        />
        <ContentRoute
          exact
          path="/hbd_author/add-author"
          component={HbdAddAuthor}
          isAccessAllow={useIsAccessAllow("hbd_author.add_author")}
        />
        <ContentRoute
          exact
          path="/hbd_author/edit-author/:id"
          component={HbdAddAuthor}
          isAccessAllow={useIsAccessAllow("hbd_author.edit_author")}
        />
        {/* HBD Author Route End */}
        {/* BDC Blog Route Start */}
        <ContentRoute
          exact
          path="/bdc_blog"
          component={BdcBlog}
          isAccessAllow={useIsAccessAllow("bdc_blog.list")}
        />
        <ContentRoute
          exact
          path="/bdc_blog/add-blog"
          component={AddBdcBlog}
          isAccessAllow={useIsAccessAllow("bdc_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/bdc_blog/edit-blog/:id"
          component={AddBdcBlog}
          isAccessAllow={useIsAccessAllow("bdc_blog.edit_blog")}
        />
        {/* BDC Blog Route End */}
        {/* BDC tag Route Start */}
        <ContentRoute
          exact
          path="/bdc_tag"
          component={BdcTag}
          isAccessAllow={useIsAccessAllow("bdc_tag.list")}
        />
        <ContentRoute
          exact
          path="/bdc_tag/add-tag"
          component={BdcTagAdd}
          isAccessAllow={useIsAccessAllow("bdc_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/bdc_tag/edit-tag/:id"
          component={BdcTagAdd}
          isAccessAllow={useIsAccessAllow("bdc_tag.edit_tag")}
        />
        {/* BDC tag Route End */}
        {/* BDC Category Route Start */}
        <ContentRoute
          exact
          path="/bdc_category"
          component={BdcCategory}
          isAccessAllow={useIsAccessAllow("bdc_category.list")}
        />
        <ContentRoute
          exact
          path="/bdc_category/add-category"
          component={BdcAddCategory}
          isAccessAllow={useIsAccessAllow("bdc_category.add_category")}
        />
        <ContentRoute
          exact
          path="/bdc_category/edit-category/:id"
          component={BdcAddCategory}
          isAccessAllow={useIsAccessAllow("bdc_category.edit_category")}
        />
        {/* BDC Category Route End */}
        {/* BDC Author Route Start */}
        <ContentRoute
          exact
          path="/bdc_author"
          component={BdcAuthor}
          isAccessAllow={useIsAccessAllow("bdc_author.list")}
        />
        <ContentRoute
          exact
          path="/bdc_author/add-author"
          component={BdcAddAuthor}
          isAccessAllow={useIsAccessAllow("bdc_author.add_author")}
        />
        <ContentRoute
          exact
          path="/bdc_author/edit-author/:id"
          component={BdcAddAuthor}
          isAccessAllow={useIsAccessAllow("bdc_author.edit_author")}
        />
        {/* BDC Author Route End */}
        {/* HFD Blog Route Start */}
        <ContentRoute
          exact
          path="/hfd_blog"
          component={HfdBlog}
          isAccessAllow={useIsAccessAllow("hfd_blog.list")}
        />
        <ContentRoute
          exact
          path="/hfd_blog/add-blog"
          component={AddHfdBlog}
          isAccessAllow={useIsAccessAllow("hfd_blog.add_blog")}
        />
        <ContentRoute
          exact
          path="/hfd_blog/edit-blog/:id"
          component={AddHfdBlog}
          isAccessAllow={useIsAccessAllow("hfd_blog.edit_blog")}
        />
        {/* HFD Blog Route End */}
        {/* HFD tag Route Start */}
        <ContentRoute
          exact
          path="/hfd_tag"
          component={HfdTag}
          isAccessAllow={useIsAccessAllow("hfd_tag.list")}
        />
        <ContentRoute
          exact
          path="/hfd_tag/add-tag"
          component={HfdTagAdd}
          isAccessAllow={useIsAccessAllow("hfd_tag.add_tag")}
        />
        <ContentRoute
          exact
          path="/hfd_tag/edit-tag/:id"
          component={HfdTagAdd}
          isAccessAllow={useIsAccessAllow("hfd_tag.edit_tag")}
        />
        {/* HFD tag Route End */}
        {/* HFD Category Route Start */}
        <ContentRoute
          exact
          path="/hfd_category"
          component={HfdCategory}
          isAccessAllow={useIsAccessAllow("hfd_category.list")}
        />
        <ContentRoute
          exact
          path="/hfd_category/add-category"
          component={HfdAddCategory}
          isAccessAllow={useIsAccessAllow("hfd_category.add_category")}
        />
        <ContentRoute
          exact
          path="/hfd_category/edit-category/:id"
          component={HfdAddCategory}
          isAccessAllow={useIsAccessAllow("hfd_category.edit_category")}
        />
        {/* HFD Category Route End */}
        {/* HFD Author Route Start */}
        <ContentRoute
          exact
          path="/hfd_author"
          component={HfdAuthor}
          isAccessAllow={useIsAccessAllow("hfd_author.list")}
        />
        <ContentRoute
          exact
          path="/hfd_author/add-author"
          component={HfdAddAuthor}
          isAccessAllow={useIsAccessAllow("hfd_author.add_author")}
        />
        <ContentRoute
          exact
          path="/hfd_author/edit-author/:id"
          component={HfdAddAuthor}
          isAccessAllow={useIsAccessAllow("hfd_author.edit_author")}
        />
        {/* HFD Author Route End */}
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
